<template>
    <div class="wbcourse">
        <div class="wb-content" @click="$emit('click', course)">
            <h4>{{ course.siteTitle }}</h4>
            <h5>{{ course.departments | flattenOes }}</h5>
            <course-badge :badgeText="courseTypeName(course.type)" :badgeColorClass="courseTypeClass(course.type)"></course-badge>
            <p class="course-headline" v-html="course.siteHeadlineHtml"></p>
            <dl>
                <dt>{{translationHelper.getTranslation("wbk_CourseCostsLabel")}}</dt><dd>{{ course.price }}</dd>
                <dt v-if="course.duration">{{translationHelper.getTranslation("wbk_CourseDurationLabel")}}</dt><dd v-if="course.duration">{{ course.duration }} {{ course.durationUnit }}</dd>
                <!-- <dt v-if="showDepartment">Departments</dt><dd v-if="showDepartment">{{ course.departments | flattenOes }}</dd> -->
            </dl>
        </div>
        <div class="wb-footer">
            <a  class="link-btn" target="_blank" :href="course.url">{{translationHelper.getTranslation("wbk_ShowMoreInfoLabel")}}</a>
            <span :class="{selected: course.isBookmarked }" class="ui-widget ui-icon-bookmark" 
            @click="$emit('bookmark', course)"></span>
        </div>
    </div>
</template>

<script>
export default {
    // props: [ "course", "bookmarked" ],
    props: {
        course: {
            type: Object,
            default: function () {
                return {
                    id: "", // guid
                    url: "", // absolute (with language)
                    type: "", // "Weiterbildungskurs", "CAS"
                    departments: [], // array of strings
                    duration: 0, // number
                    durationUnit: '', // eg 'Tage'
                    siteHeadlineHtml: '', // short description of the course in html
                    siteTitle: '', // title of the course
                    price: '', // eg 'CHF 7'900.-'
                    isBookmarked: false // true / false if bookmarked by current user
                }
            }
        },
        translationHelper: {
         type: Object
        }
    },
    components: {
      CourseBadge: () => import("./CourseBadge.vue"),
    },
    filters: {
        flattenOes: function(value) {
            if (!value) return ''
            if (typeof value === 'string') return value
            if (Array.isArray(value)) {
                return value.join(', ')
            }
        },
    },
    methods:{
        courseTypeClass: function(value) {
            if (!value) return ''
            switch(value) {
            case 'Weiterbildungskurs':
                return 'kurs'
            case 'CAS':
                return  'cas'
            case 'MAS':
                return  'mas'
            case 'DAS':
                return  'das'
            case 'Seminar':
                return  'seminar'
            case 'EMBA':
                return  'emba'
            case 'MBA':
                return  'mba'  
            case 'Andere':
                return 'other'
            case 'DBA':
                return  'dba'
            default:
                return 'ndf'
            }
        },
        courseTypeName: function(value) {
            if (!value) return ''
            switch(value) {
            case 'Weiterbildungskurs':
                return this.translationHelper.getTranslation("wbk_FilterNameCourse").toLowerCase()
            case 'CAS':
                return  this.translationHelper.getTranslation("wbk_FilterNameCas").toLowerCase()
            case 'MAS':
                return  this.translationHelper.getTranslation("wbk_FilterNameMas").toLowerCase()
            case 'DAS':
                return  this.translationHelper.getTranslation("wbk_FilterNameDas").toLowerCase()
            case 'Seminar':
                return  this.translationHelper.getTranslation("wbk_FilterNameSeminar").toLowerCase()
            case 'EMBA':
                return  this.translationHelper.getTranslation("wbk_FilterNameEmba").toLowerCase()
            case 'MBA':
                return  this.translationHelper.getTranslation("wbk_FilterNameMba").toLowerCase()
            case 'Andere':
                return  this.translationHelper.getTranslation("wbk_FilterNameOther").toLowerCase()
            case 'DBA':
                return  this.translationHelper.getTranslation("wbk_FilterNameDba").toLowerCase()
            default:
                return value.toLowerCase()
            }
        }

    }
}
</script>